import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  min-height: 100vh;
}

.access-page {
  align-items: center;
  background: radial-gradient(circle at 12% 8%, rgba(16, 185, 129, 0.16), transparent 27rem), radial-gradient(circle at 88% 92%, rgba(59, 130, 246, 0.1), transparent 25rem), linear-gradient(145deg, #edf6f1 0%, #f7faf8 48%, #eef4f7 100%);
  display: flex;
  justify-content: center;
  min-height: 100vh;
  overflow: hidden;
  padding: 2rem;
  position: relative;
}

.access-ambient {
  border: 1px solid rgba(255, 255, 255, 0.55);
  border-radius: 9999px;
  pointer-events: none;
  position: absolute;
}

.access-ambient-one {
  height: 26rem;
  left: -13rem;
  top: -12rem;
  width: 26rem;
}

.access-ambient-two {
  bottom: -15rem;
  height: 32rem;
  right: -16rem;
  width: 32rem;
}

.access-shell {
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(255, 255, 255, 0.78);
  border-radius: 1.5rem;
  box-shadow: 0 35px 85px rgba(15, 23, 42, 0.16);
  min-height: 42rem;
  position: relative;
  z-index: 1;
}

.access-brand-panel {
  background: radial-gradient(circle at 92% 10%, rgba(110, 231, 183, 0.18), transparent 19rem), radial-gradient(circle at 5% 90%, rgba(52, 211, 153, 0.1), transparent 16rem), linear-gradient(145deg, #053d30 0%, #064e3b 54%, #065f46 100%);
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  padding: 2.6rem 2.75rem;
  position: relative;
}

.access-brand-panel::before,
.access-brand-panel::after {
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 9999px;
  content: "";
  position: absolute;
}

.access-brand-panel::before {
  height: 18rem;
  right: -9rem;
  top: -8rem;
  width: 18rem;
}

.access-brand-panel::after {
  bottom: -7rem;
  height: 16rem;
  left: -7rem;
  width: 16rem;
}

.access-brand-content,
.access-brand-footer {
  position: relative;
  z-index: 1;
}

.access-brand-mark {
  align-items: center;
  background: rgba(255, 255, 255, 0.96);
  border-radius: 0.9rem;
  display: inline-flex;
  min-height: 3.7rem;
  padding: 0.45rem 0.8rem;
}

.access-brand-copy {
  margin-top: 3.2rem;
}

.access-kicker {
  color: #6ee7b7;
  font-size: 0.625rem;
  font-weight: 850;
  letter-spacing: 0.16em;
}

.access-brand-title {
  font-size: clamp(1.8rem, 3.1vw, 2.55rem);
  font-weight: 750;
  letter-spacing: -0.055em;
  line-height: 1.23;
  margin-top: 0.85rem;
}

.access-brand-title span {
  color: #a7f3d0;
}

.access-brand-description {
  color: rgba(236, 253, 245, 0.7);
  font-size: 0.78rem;
  line-height: 1.75;
  margin-top: 1rem;
  max-width: 26rem;
}

.access-feature-list {
  display: grid;
  gap: 0.75rem;
  margin-top: 2.25rem;
}

.access-feature-item {
  align-items: center;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0.85rem;
  display: flex;
  gap: 0.75rem;
  padding: 0.75rem;
}

.access-feature-icon {
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 0.65rem;
  color: #a7f3d0;
  display: flex;
  flex-shrink: 0;
  height: 2.25rem;
  justify-content: center;
  width: 2.25rem;
}

.access-feature-title {
  font-size: 0.72rem;
  font-weight: 750;
}

.access-feature-description {
  color: rgba(236, 253, 245, 0.58);
  font-size: 0.625rem;
  margin-top: 0.15rem;
}

.access-brand-footer {
  align-items: center;
  color: rgba(236, 253, 245, 0.5);
  display: flex;
  font-size: 0.5625rem;
  font-weight: 650;
  gap: 0.5rem;
  letter-spacing: 0.04em;
  margin-top: 1.5rem;
}

.access-status-dot {
  background: #6ee7b7;
  border-radius: 9999px;
  box-shadow: 0 0 0 4px rgba(110, 231, 183, 0.12);
  height: 0.4rem;
  width: 0.4rem;
}

.access-form-panel {
  align-self: stretch;
  background: rgba(255, 255, 255, 0.94);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2.6rem 3.15rem 2rem;
}

.access-mobile-logo {
  display: none;
}

.access-tabs {
  background: #f2f6f4;
  border: 1px solid #e1e9e5;
  border-radius: 0.8rem;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  padding: 0.25rem;
}

.access-tab {
  border-radius: 0.6rem;
  color: #64748b;
  font-size: 0.72rem;
  font-weight: 700;
  height: 2.4rem;
  transition: background-color 160ms ease, box-shadow 160ms ease, color 160ms ease;
}

.access-tab.is-active {
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.07);
  color: #065f46;
}

.access-form-heading {
  margin-top: 2rem;
}

.access-form-kicker {
  color: #059669;
  font-size: 0.5625rem;
  font-weight: 850;
  letter-spacing: 0.14em;
}

.access-form-title {
  color: #0f172a;
  font-size: 1.45rem;
  font-weight: 750;
  letter-spacing: -0.045em;
  margin-top: 0.4rem;
}

.access-form-description {
  color: #64748b;
  font-size: 0.7rem;
  line-height: 1.6;
  margin-top: 0.4rem;
}

.access-form {
  margin-top: 1.7rem;
}

.access-field {
  display: block;
}

.access-label {
  color: #334155;
  display: block;
  font-size: 0.7rem;
  font-weight: 700;
  margin-bottom: 0.4rem;
}

.access-input-wrap {
  position: relative;
}

.access-input-icon {
  color: #94a3b8;
  height: 1rem;
  left: 0.9rem;
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 1rem;
}

.access-password-toggle {
  align-items: center;
  border-radius: 0.55rem;
  color: #94a3b8;
  display: flex;
  height: 2.25rem;
  justify-content: center;
  position: absolute;
  right: 0.4rem;
  top: 50%;
  transform: translateY(-50%);
  transition: background-color 150ms ease, color 150ms ease;
  width: 2.25rem;
}

.access-password-toggle:hover {
  background: #f1f5f9;
  color: #475569;
}

.access-password-toggle:focus-visible {
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.16);
  color: #047857;
  outline: none;
}

.access-input {
  background: #ffffff;
  border: 1px solid #d5dee8;
  border-radius: 0.75rem;
  box-shadow: 0 3px 8px rgba(15, 23, 42, 0.025);
  color: #0f172a;
  font-size: 0.75rem;
  height: 3rem;
  outline: none;
  padding: 0 0.9rem 0 2.65rem;
  transition: border-color 150ms ease, box-shadow 150ms ease;
  width: 100%;
}

.access-input-with-action {
  padding-right: 3rem;
}

.access-input::placeholder {
  color: #a8b3bf;
}

.access-input:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.11);
}

.access-security-note {
  align-items: center;
  color: #64748b;
  display: flex;
  font-size: 0.625rem;
  gap: 0.45rem;
}

.access-security-icon {
  align-items: center;
  background: #ecfdf5;
  border-radius: 9999px;
  color: #059669;
  display: flex;
  height: 1.55rem;
  justify-content: center;
  width: 1.55rem;
}

.access-trust-card {
  align-items: flex-start;
  background: linear-gradient(145deg, #f0fdf4 0%, #f8fafc 100%);
  border: 1px solid #bbf7d0;
  border-radius: 0.85rem;
  display: flex;
  gap: 0.7rem;
  padding: 0.8rem 0.85rem;
}

.access-trust-icon {
  align-items: center;
  background: #dcfce7;
  border-radius: 0.65rem;
  color: #047857;
  display: flex;
  flex: 0 0 auto;
  height: 2rem;
  justify-content: center;
  width: 2rem;
}

.access-trust-title {
  color: #064e3b;
  font-size: 0.6875rem;
  font-weight: 800;
}

.access-trust-description {
  color: #526276;
  font-size: 0.625rem;
  line-height: 1.65;
  margin-top: 0.25rem;
}

.access-trust-points {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  margin-top: 0.55rem;
}

.access-trust-points span {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #d1fae5;
  border-radius: 9999px;
  color: #047857;
  font-size: 0.5625rem;
  font-weight: 700;
  padding: 0.2rem 0.45rem;
}

.access-submit-button,
.access-outline-button {
  align-items: center;
  border-radius: 0.75rem;
  display: flex;
  font-size: 0.75rem;
  font-weight: 750;
  gap: 0.5rem;
  height: 3rem;
  justify-content: center;
  transition: box-shadow 160ms ease, transform 160ms ease;
  width: 100%;
}

.access-submit-button {
  background: linear-gradient(135deg, #065f46, #047857);
  box-shadow: 0 10px 22px rgba(6, 78, 59, 0.2);
  color: #ffffff;
}

.access-submit-button:hover {
  box-shadow: 0 14px 28px rgba(6, 78, 59, 0.25);
  transform: translateY(-1px);
}

.access-outline-button {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  color: #475569;
  margin-top: 1.2rem;
}

.access-outline-button:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.signup-flow {
  display: grid;
  gap: 0.65rem;
  margin-top: 1.45rem;
}

.signup-step {
  align-items: flex-start;
  background: linear-gradient(145deg, #ffffff, #f9fbfa);
  border: 1px solid #e2e8f0;
  border-radius: 0.8rem;
  display: flex;
  gap: 0.75rem;
  padding: 0.75rem;
}

.signup-step-number {
  align-items: center;
  background: #ecfdf5;
  border: 1px solid #d1fae5;
  border-radius: 0.55rem;
  color: #047857;
  display: flex;
  flex-shrink: 0;
  font-size: 0.5625rem;
  font-weight: 850;
  height: 2rem;
  justify-content: center;
  width: 2rem;
}

.signup-step-title {
  color: #1e293b;
  font-size: 0.7rem;
  font-weight: 750;
}

.signup-step-description {
  color: #64748b;
  font-size: 0.61rem;
  line-height: 1.5;
  margin-top: 0.2rem;
}

.signup-notice {
  align-items: flex-start;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 0.8rem;
  display: flex;
  gap: 0.7rem;
  margin-top: 0.8rem;
  padding: 0.8rem;
}

.signup-notice-icon {
  color: #c2410c;
  flex-shrink: 0;
}

.signup-notice-title {
  color: #9a3412;
  font-size: 0.68rem;
  font-weight: 750;
}

.signup-notice-description {
  color: #c2410c;
  font-size: 0.6rem;
  line-height: 1.5;
  margin-top: 0.2rem;
}

.access-footer-copy {
  color: #a1aab6;
  font-size: 0.5625rem;
  margin-top: auto;
  padding-top: 1.5rem;
  text-align: center;
}

.invite-office-card,
.invite-state-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.9rem;
  color: #64748b;
  display: flex;
  flex-direction: column;
  font-size: 0.7rem;
  gap: 0.35rem;
  padding: 1rem;
}

.invite-office-label {
  color: #64748b;
  font-size: 0.625rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.invite-office-name {
  color: #0f172a;
  font-size: 0.9rem;
}

.invite-office-meta {
  color: #64748b;
  font-size: 0.625rem;
}

.invite-state-card {
  align-items: center;
  margin-top: 1.5rem;
  text-align: center;
}

.invite-state-card.is-error {
  background: #fff7f7;
  border-color: #fecaca;
  color: #b91c1c;
}

.invite-state-card.is-success {
  background: #f0fdf4;
  border-color: #bbf7d0;
  color: #166534;
}

.invite-state-title {
  color: #0f172a;
  font-size: 0.82rem;
  font-weight: 750;
}

.invite-success-icon {
  align-items: center;
  background: #dcfce7;
  border-radius: 999px;
  color: #15803d;
  display: inline-flex;
  height: 2.5rem;
  justify-content: center;
  margin-bottom: 0.25rem;
  width: 2.5rem;
}

.invite-state-spinner {
  animation: invite-spin 0.8s linear infinite;
  border: 2px solid #dbeafe;
  border-radius: 999px;
  border-top-color: #2563eb;
  height: 1.5rem;
  width: 1.5rem;
}

@keyframes invite-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 1023px) {
  .access-page {
    padding: 1.25rem;
  }
  .access-shell {
    max-width: 31rem;
    min-height: 0;
  }
  .access-brand-panel {
    display: none;
  }
  .access-form-panel {
    padding: 2rem 2.2rem 1.6rem;
  }
  .access-mobile-logo {
    display: flex;
    justify-content: center;
    margin-bottom: 1.6rem;
  }
}
@media (max-width: 639px) {
  .access-page {
    align-items: flex-start;
    padding: 0;
  }
  .access-shell {
    border: 0;
    border-radius: 0;
    box-shadow: none;
    min-height: 100vh;
  }
  .access-form-panel {
    justify-content: flex-start;
    padding: 2rem 1.25rem 1.25rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  .access-tab,
  .access-input,
  .access-submit-button,
  .access-outline-button {
    transition: none;
  }
  .access-submit-button:hover {
    transform: none;
  }
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public view: string = 'login';
    public invitationToken: string = '';
    public invitation: any = null;
    public invitationCsrf: string = '';
    public invitationLoading: boolean = false;
    public invitationAccepted: boolean = false;
    public invitationError: string = '';
    public invitationAcceptanceError: string = '';
    public loginNotice: string = '';
    public passwordVisible: boolean = false;
    public offices: any[] = [];
    public officeSelectCsrf: string = '';
    public officeSelectError: string = '';
    public officeSelectionLoading: boolean = false;

    public data: any = {
        email: '',
        password: ''
    };

    public invitationForm: any = {
        email: '',
        password: '',
        passwordConfirm: ''
    };

    public async ngOnInit() {
        this.invitationToken = this.consumeInvitationToken();
        await this.service.init();
        const params = new URLSearchParams(location.search);
        if (params.get('reason') === 'session_replaced') {
            this.loginNotice = '다른 컴퓨터 또는 브라우저에서 이 계정으로 로그인하여 기존 접속이 자동으로 종료되었습니다.';
        }
        if (this.invitationToken) {
            this.view = 'invite';
            await this.loadInvitation();
            return;
        }
        const requestedView = params.get('view');
        const check = await this.service.auth.check();
        if (check) {
            if (requestedView === 'office' || !this.service.auth.session?.tenant_id) {
                await this.loadOffices();
                return;
            }
            location.href = this.redirectUri();
            return;
        }
        this.view = requestedView === 'signup' ? 'signup' : 'login';
        await this.service.render();
    }

    public async loadOffices() {
        this.officeSelectionLoading = true;
        this.officeSelectError = '';
        this.view = 'office';
        await this.service.render();
        const { code, data } = await wiz.call('list_offices');
        this.officeSelectionLoading = false;
        if (code === 200) {
            this.offices = data.offices || [];
            this.officeSelectCsrf = data.csrf_token || '';
            if (!this.offices.length) {
                this.officeSelectError = '사용할 수 있는 사무소가 없습니다. 웅빈 관리자에게 소속 상태를 확인해주세요.';
            }
        } else {
            this.officeSelectError = data?.message || '소속 사무소를 불러오지 못했습니다.';
        }
        await this.service.render();
    }

    public async chooseOffice(tenantId: string) {
        if (this.officeSelectionLoading || !this.officeSelectCsrf) return;
        this.officeSelectionLoading = true;
        this.officeSelectError = '';
        await this.service.render();
        const { code, data } = await wiz.call('select_office', {
            tenant_id: tenantId,
            csrf_token: this.officeSelectCsrf
        });
        this.officeSelectionLoading = false;
        if (code === 200) {
            location.href = this.redirectUri();
            return;
        }
        this.officeSelectError = data?.message || '사무소를 선택하지 못했습니다.';
        await this.service.render();
    }

    public async loadInvitation() {
        this.invitationLoading = true;
        this.invitationError = '';
        this.invitationAcceptanceError = '';
        await this.service.render();
        const { code, data } = await wiz.call('invitation', { token: this.invitationToken });
        this.invitationLoading = false;
        if (code === 200) {
            this.invitation = data.invitation;
            this.invitationCsrf = data.csrf_token;
        } else {
            this.invitationError = data.message || '유효한 초대를 확인할 수 없습니다.';
        }
        await this.service.render();
    }

    public async acceptInvitation() {
        if (!this.invitation || this.invitationLoading) return;
        if (!this.invitationForm.email) {
            await this.alert('초대받은 이메일을 입력해주세요.');
            return;
        }
        if (this.invitation.requires_password) {
            if (!this.invitationForm.password || this.invitationForm.password.length < 10) {
                await this.alert('문자와 숫자를 포함한 10자 이상의 비밀번호를 입력해주세요.');
                return;
            }
            if (this.invitationForm.password !== this.invitationForm.passwordConfirm) {
                await this.alert('비밀번호 확인이 일치하지 않습니다.');
                return;
            }
        }
        this.invitationLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call('accept_invitation', {
            token: this.invitationToken,
            csrf_token: this.invitationCsrf,
            tenant_id: this.invitation.tenant_id,
            email: this.invitationForm.email,
            password: this.invitation.requires_password ? this.invitationForm.password : '',
            password_confirm: this.invitation.requires_password ? this.invitationForm.passwordConfirm : ''
        });
        this.invitationLoading = false;
        if (code === 200) {
            this.invitationAccepted = true;
            this.data.email = this.invitationForm.email;
            this.invitationToken = '';
            this.invitationCsrf = '';
            if (data.result?.existing_account && data.result?.tenant_id) {
                await this.loadOffices();
                if (this.officeSelectCsrf && this.offices.some((office) => office.tenant_id === data.result.tenant_id)) {
                    await this.chooseOffice(data.result.tenant_id);
                }
                return;
            }
        } else {
            this.invitationAcceptanceError = data.message || '초대를 수락할 수 없습니다.';
        }
        await this.service.render();
    }

    public async moveToLogin() {
        this.view = 'login';
        this.invitationToken = '';
        this.invitation = null;
        this.invitationAccepted = false;
        await this.service.render();
    }

    public async loginForInvitation() {
        this.view = 'login';
        this.loginNotice = '초대받은 이메일의 기존 계정으로 로그인하면 초대 수락 화면으로 돌아갑니다.';
        await this.service.render();
    }

    public async requestReinvitation() {
        this.view = 'signup';
        this.invitationToken = '';
        await this.service.render();
    }

    public async setView(view: string) {
        this.view = view === 'signup' ? 'signup' : 'login';
        await this.service.render();
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async togglePasswordVisibility() {
        this.passwordVisible = !this.passwordVisible;
        await this.service.render();
    }

    public async login() {
        let user = JSON.parse(JSON.stringify(this.data));
        if (!user.email) {
            await this.alert("이메일을 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        // user.password = this.service.auth.hash(user.password);

        let { code, data } = await wiz.call("login", user);

        if (code == 200) {
            if (this.invitationToken && this.invitation) {
                this.view = 'invite';
                await this.loadInvitation();
                return;
            }
            if (data?.session?.must_change_password) {
                location.href = '/mypage?forcePasswordChange=1#password-change';
                return;
            }
            if (!data?.session?.tenant_id) {
                await this.loadOffices();
                return;
            }
            location.href = this.redirectUri();
            return;
        } else {
            await this.alert(data.message || "로그인에 실패했습니다.", 'error');
        }
    }

    private consumeInvitationToken() {
        const url = new URL(location.href);
        const fragment = new URLSearchParams(url.hash.replace(/^#/, ''));
        const token = fragment.get('invite') || url.searchParams.get('token') || '';
        if (token) {
            url.hash = '';
            url.searchParams.delete('token');
            history.replaceState({}, '', url.pathname + url.search);
        }
        return token;
    }

    private redirectUri() {
        const params = new URLSearchParams(location.search);
        const returnTo = params.get('returnTo') || '/dashboard';
        if (returnTo.startsWith('/') && !returnTo.startsWith('//')) return returnTo;
        return '/dashboard';
    }
}

export default PageAccessComponent;